<div class="wrapper">
  <img class="avatar" [src]="userData.avatar" alt="user avatar" />
  <span class="user-name">{{ userData.name }}</span>
  @if (isRemovable) {
  <button (click)="removeAddedUser(userData.uid)" class="del-btn">
    <svg
      class="del-icon"
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.93125 5.98125L1.25625 9.65625C1.11875 9.79375 0.94375 9.8625 0.73125 9.8625C0.51875 9.8625 0.34375 9.79375 0.20625 9.65625C0.06875 9.51875 0 9.34375 0 9.13125C0 8.91875 0.06875 8.74375 0.20625 8.60625L3.88125 4.93125L0.20625 1.25625C0.06875 1.11875 0 0.94375 0 0.73125C0 0.51875 0.06875 0.34375 0.20625 0.20625C0.34375 0.06875 0.51875 0 0.73125 0C0.94375 0 1.11875 0.06875 1.25625 0.20625L4.93125 3.88125L8.60625 0.20625C8.74375 0.06875 8.91875 0 9.13125 0C9.34375 0 9.51875 0.06875 9.65625 0.20625C9.79375 0.34375 9.8625 0.51875 9.8625 0.73125C9.8625 0.94375 9.79375 1.11875 9.65625 1.25625L5.98125 4.93125L9.65625 8.60625C9.79375 8.74375 9.8625 8.91875 9.8625 9.13125C9.8625 9.34375 9.79375 9.51875 9.65625 9.65625C9.51875 9.79375 9.34375 9.8625 9.13125 9.8625C8.91875 9.8625 8.74375 9.79375 8.60625 9.65625L4.93125 5.98125Z"
        fill="black"
      />
    </svg>
  </button>
  }
</div>
